import { AggregationSection, ProductCollectionFilter } from '../../../../types';
import { SupportedSection } from './types';

export const isValidSection = (
  section: AggregationSection
): section is SupportedSection => {
  return [
    'ListSection',
    'RangeSection',
    'RangeGroupSection',
    'BooleanSection',
  ].includes(section.__typename || '');
};

export const isDisabledSection = (section: AggregationSection) => {
  switch (section.__typename) {
    case 'ListSection':
      return !section.items || !section.items.length;
    case 'RangeSection':
      return section.min === section.max;
    default:
      return false;
  }
};

export const getSelectedListItems = (
  filter: ProductCollectionFilter | undefined
) => {
  if (!filter) return undefined;

  switch (filter.__typename) {
    case 'ProductCollectionTermFilter':
      return filter.value
        ? [{ id: filter.id, value: filter.value }]
        : undefined;

    case 'ProductCollectionTermsFilter':
      return filter.values
        ? filter.values
            .map((value, index) => ({ id: filter.ids[index], value }))
            .sort((a, b) => a.value.localeCompare(b.value))
        : undefined;

    default:
      return undefined;
  }
};
